import service from '@/services/superaccess'

const backup = {
  state: {
    backup_modal: false
  },
  mutations: {
    updateStatusBackupModal (state, status) {
      state.restore_modal = status
    }
  },
  actions: {
    setStatusBackupModal (context, payload) {
      context.commit('updateStatusBackupModal', payload)
    },
    backup (context, payload) {
      return service.post('/api/configuration/backup', context)
    },
    setTimeBackup (context, payload) {
      return service.post('/api/configuration/backup_time', context, { data: payload })
    },
    getTimeBackup (context, payload) {
      return service.post('/api/configuration/backup_get_time', context)
    },
    retrieveDevices (context, payload) {
      return service.post('/api/configuration/devices', context)
    }
  }
}

export default backup



// WEBPACK FOOTER //
// app/javascript/src/store/backup.js